import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";

import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import GetDomains from '../GetDomains'
import Loader from 'react-loader-spinner';
import Select from 'react-select';

class Faq extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, hideDeleteAllPopup: false, hideIncorrectPassword: false });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        }; this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };


        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteFaqApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //deleteall
        this.deleteAllButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                    hideTextAreaPopup: true
                });
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                    hideTextAreaPopup: false
                });
            }
        }];




        //deleteall
        this.textAreaConfir = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.deleteInputValidation()
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: false,
                });
            }
        }];
        //incorrectPasswordButtons
        this.incorrectPasswordButtons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: true,
                    hideIncorrectPassword: false

                })
            }
        }];

        this.state = {
            inEditState: false,
            language: null,
            showClearButton: false,
            showClearButtonOnclick: false,
            hideDeleteAllPopup: false,
            hideIncorrectPassword: false,
            data: [
                {
                    id: '',
                    question: '',
                    originalQuestionId: '',
                    // categoryTags: '',
                    autoTranslate: '',
                    alias: '',
                }
            ],
            pageNum: null,
            faqOriginalQuestionId: null,
            faqid: null,
            domains: [],
            domainId: null,
            languageId: null,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            selectedDomainValue: null,
            selectedLanguageValue: null,
            hideTextAreaPopup: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.domains = [];
        this.faqLoadLanguages = [];
    }

    notifyFailedToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addFaq = (data) => {
        var thisController = this;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            question: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }
    deleteInputValidation = () => {
        if (document.getElementById('deleteInputFromUser').value == "Delete" ||
            document.getElementById('deleteInputFromUser').value == "delete" ||
            document.getElementById('deleteInputFromUser').value == "DELETE") {
            document.getElementById('deleteInputFromUser').value = "";
            this.deleteAllFaqApi();
        }
        else {
            this.setState({
                hideIncorrectPassword: true
            })
        }
    }


    saveFaqApi = (props, e) => {
        var domainId = this.state.domainId;
        var language = this.state.languageId
        this.state.data[props.index].question = document.getElementById("question" + props.index).innerText.trim();
        this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;

        this.state.editedId = "-1";
        this.setState(this.state);
        var validateResult = this.validateCells(props.original.question);

        if (validateResult == true) {
            var addedData = {
                question: this.state.data[props.index].question,
                projectId: localStorage.getItem("currentProjectId"),
                domainId: domainId,
                language: language,
                autoTranslate: this.state.data[props.index].autoTranslate,

            };

            var thisController = this
            $.ajax({
                url: "/api/faq-question",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: addedData,
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyAdd();
                        thisController.state.disabled = false;
                        thisController.fetchFaqDataApi();
                    } else {
                        thisController.notifyFailedToAddFaq(res.result);
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }
    notifyAdd() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;FAQ Added Successfully</b>, {
            position: "top-center",

        });

    }

    notifyFailedToAddFaq(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {
        this.state.inEditState = true;
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateFaqApi(props, e) {
        this.state.data[props.index].question = document.getElementById("question" + props.index).innerText.trim();
        this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;

        var validateResult = this.validateCells(props.original.question);
        if (validateResult == true) {
            var updatedData = {
                question: this.state.data[props.index].question,
                questionId: this.state.data[props.index].id,
                domainId: props.original.domainId,
                autoTranslate: this.state.data[props.index].autoTranslate,
            };
            var thisController = this
            $.ajax({
                url: "/api/faq-question-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'contentType': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: updatedData,
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdate();
                        thisController.fetchFaqDataApi();
                    } else {
                        thisController.notifyFailedToUpdate(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;FAQ Updated Successfully</b>, {
            position: "top-center",

        });
    }
    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(question) {
        if ((question == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    deleteFaqApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
            deleteRowViewController.loadData();
        }
        $.ajax({
            url: "/api/faq-question/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteConstructorVariables.notifyDeleted();
                    deleteConstructorVariables.fetchFaqDataApi();

                } else {
                    deleteConstructorVariables.notifyFailedToDelete(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyDeleted() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;FAQ Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    notifyFailedToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    //---------------Delete all------------------------//
    deleteAllFaqApi = () => {
        let thisController = this;
        var domainId = this.state.domainId;
        var language = this.state.languageId
        $.ajax({
            url: "/api/faqQuestions/delete/all",
            async: false,
            method: 'POST',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                domainId: domainId,
                language: language
            },
            success: function (res) {

                if (res.success === true && res.result === "done.") {
                    thisController.state.hideTextAreaPopup = false;
                    thisController.state.checkBoxRows = [];
                    thisController.setState(thisController.state);
                    thisController.fetchFaqDataApi();
                    thisController.notifyDeleteAllSuccess();
                } else if (res.success === true && res.result != "done.") {

                    thisController.notifyNodata(res.result);
                }


                else {
                    thisController.notifyFailedToDelete(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }


    notifyFailedToDelete(response) {

        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }

    notifyNodata(response) {

        this.setState({
            hideTextAreaPopup: false
        })
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }
    notifyDeleteAllSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;All FAQs have been deleted Successfully</b>, {
            position: "top-center",
        });

    }
    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchFaqDataApi()
        this.setState({ disabled: false })
    }

    handleLangChange = (e) => {
        this.state.selectedLanguageValue = e.label;
        this.state.languageId = e.value;
        localStorage.setItem("name", e.label);
        localStorage.setItem("languageId", e.value);
        this.setState(this.state);
        this.fetchFaqDataApi();
    }


    handleDomainChange = (e) => {
        this.state.selectedDomainValue = e.label;
        this.state.domainId = e.value;
        localStorage.setItem("faqDomainName", e.label);
        localStorage.setItem("faqDomainId", e.value);
        this.setState(this.state);
        this.fetchFaqDataApi();
    }

    notifyFailedToLoadLanguages() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }
    fetchLanguagesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        thisController.state.successResp = false;
        var isLanguageInCurrentProject = false;
        $.ajax(
            {
                url: "/api/project-languages-selected",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                success: function (res) {
                    if (res.success === true) {
                        var loadlanguage = res.result;
                        thisController.state.successResp = true;
                        for (var i = 0; i < loadlanguage.length; i++) {
                            if (localStorage.getItem("languageId") !== undefined &&
                                loadlanguage[i]["code"] === localStorage.getItem("languageId")) {
                                isLanguageInCurrentProject = true;
                            }
                            thisController.faqLoadLanguages.push({ 'value': loadlanguage[i]['code'], 'label': loadlanguage[i]['name'] })
                        }

                        if (thisController.props.location.state !== undefined) {
                            if (isLanguageInCurrentProject) {
                                thisController.state.selectedLanguageValue = localStorage.getItem("name");
                                thisController.state.languageId = localStorage.getItem("languageId");
                            } else {
                                thisController.state.selectedLanguageValue = thisController.faqLoadLanguages[0].label;
                                thisController.state.languageId = loadlanguage[0]["code"];
                            }
                        } else {
                            thisController.state.selectedLanguageValue = thisController.faqLoadLanguages[0].label;
                            thisController.state.languageId = loadlanguage[0]["code"];
                        }
                        thisController.setState(thisController.state);
                    } else {
                        thisController.notifyFailedToLoadLanguages();
                    }
                }
            }
        )
    }

    validateLoadingData = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let searchDataMap = ""
        var domainId = this.state.domainId;
        var languageId = this.state.languageId;
        if (document.getElementById('query') != null &&
            document.getElementById('query') != "") {
            var searchQuery = document.getElementById('query').value
            let searchDataMap = {
                "projectId": projectId,
                'language': languageId,
                'domainId': domainId,
                'query': searchQuery,
            }
            return searchDataMap
        }
        searchDataMap = {
            "projectId": projectId,
            'language': languageId,
            'domainId': domainId,
        }
        return searchDataMap;
    }

    queryHandleChange = (e) => {
        if (e.key === "Enter") {
            this.fetchFaqDataApi()
        }
    }
    handleQuery = () => {
        this.fetchFaqDataApi()
    }

    fetchFaqDataApi = (projectId) => {

        var thisController = this;
        thisController.state.successResp = false;
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var updatedData = this.validateLoadingData(projectId);
        $.ajax({
            url: "/api/faq-question/search",
            async: false,
            method: 'GET',
            data: updatedData,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.inEditState = false;
                    var messages = res.result;
                    thisController.setState({
                        data: messages,
                        successResp: true,
                        disabled: false,
                    })
                }
                else {
                    thisController.notifyFailedToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchDomainsApi = () => {
        var domainList = GetDomains();
        var isDomainIdInCurrentProject = false;
        for (var i = 0; i < domainList.length; i++) {
            if (localStorage.getItem("faqDomainId") !== undefined &&
                domainList[i]["domainId"] === localStorage.getItem("faqDomainId")) {
                isDomainIdInCurrentProject = true;
            }
            this.domains.push({ "value": domainList[i]["domainId"], "label": domainList[i]["domain"] });
        }

        if (this.props.location.state !== undefined) {
            if (isDomainIdInCurrentProject) {
                this.state.selectedDomainValue = localStorage.getItem("faqDomainName");
                this.state.domainId = localStorage.getItem("faqDomainId");
            } else {
                this.state.selectedDomainValue = this.domains[0].label;
                this.state.domainId = domainList[0]["domainId"];
            }
        } else {
            this.state.selectedDomainValue = this.domains[0].label;
            this.state.domainId = domainList[0]["domainId"];
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchDomainsApi();
            this.fetchLanguagesApi();
            this.fetchFaqDataApi();
        }, 300);

        if (this.props.location.state != undefined) {
            this.setState({ pageNum: this.props.location.state.pageNum });
        }


        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.domains = [];
            thisController.faqLoadLanguages = [];
            thisController.projectId = event.projectId;
            thisController.fetchLanguagesApi(event.projectId);
            thisController.fetchDomainsApi();
            thisController.fetchFaqDataApi(event.projectId);
            thisController.state.disabled = false;
        })
    }

    otherForms = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/faq-otherForms-details',
            state: {
                faqid: props.original.id,
                pageNum: this.state.pageNum
            }
        });
        this.setState(this.setState)
    }

    answers = (props, e) => {
        var pageNum = this.state.pageNum;
        this.props.history.push({
            pathname: '/projectmgmt/faq-answer-details',
            state: {
                faqid: props.original.id,
                pageNum: pageNum
            }
        });
        this.setState(this.setState)
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    reset = () => {

        if (document.getElementById('query').innerText == '') {
            this.setState({ showClearButton: false })
        }


        var resetButton = document.getElementById("query");

        if (resetButton) {
            resetButton.value = "";

        }
        this.fetchFaqDataApi();
    }
    contentChange = (e) => {
        if (e.target.value == "") {
            this.setState({ showClearButton: false })

        } else {
            this.setState({ showClearButton: true })

        }
    }

    handleTableDomainChange = (props, e) => {
        props.original.domainId = e.target.value;
        props.original.autoTranslate = document.getElementById("autoTranslate" + props.index).checked;
        props.original.question = document.getElementById("question" + props.index).innerText;
        this.setState(this.state);
    }

    render() {
        const selectedDomainOption = this.state.selectedDomainValue;
        const selectedLanguageOption = this.state.selectedLanguageValue;
        const { data } = this.state
        const columns = [
            {
                Header: 'Qno',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Question</b>,
                accessor: 'question',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == "") ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"question" + props.index}
                >{props.original.question}</div>
                )
            },
            {
                Header: <b>Category</b>,
                accessor: 'category',
                sortable: false,
                width: 200,
                show: this.state.inEditState,
                Cell: props => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <select type="select-multiple" className="input-group form-control select2 "
                            value={props.original.domainId} id={"domain" + props.index}
                            onChange={(e) => this.handleTableDomainChange(props, e)}
                            style={{ background: 'white', border: 'none' }}
                            disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}>
                            {this.domains.map(domain => (
                                <option key={domain.value} value={domain.value} >
                                    {domain.label}
                                </option>
                            ))}
                        </select>
                    </div>)
            },
            {
                Header: <b> AutoTranslate </b>,
                accessor: 'autoTranslate',
                sortable: false,
                width: 100,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"autoTranslate" + props.index}
                                    defaultChecked={props.original.autoTranslate}
                                    disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> Action </b>,
                accessor: 'action',
                width: 250,
                overflow: "visible",
                sortable: false,
                Cell: props => (
                    <div id="action">
                        <div >
                            <button className="btn2 table-action-button "
                                onClick={(e) => {
                                    this.otherForms(props, e)
                                }}
                                hidden={(props.original.id == "") ? true : false}>
                                Variations</button>

                            <button className="btn2 table-action-button "
                                onClick={(e) => {
                                    this.answers(props, e)
                                }}
                                hidden={(props.original.id == "") ? true : false}>
                                Answers</button>
                            {/* edit button */}
                            <button
                                style={{
                                    backgroundColor: "#ffffff", border: "none",
                                    marginTop: '-13px'
                                }}
                            >
                                <img className="img-responsive"
                                    style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                    title={(props.original.id == "") ||
                                        (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                    src={(props.original.id == "") ?
                                        this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                            this.editImageSrc : this.saveImageSrc)}
                                    onClick={(e) => {
                                        (props.original.id == "") ?
                                            this.saveFaqApi(props, e) :
                                            (props.original.id == this.state.editedId) ?
                                                this.updateFaqApi(props, e) :
                                                this.makeCelleditable(props, e);
                                    }}
                                />
                            </button>
                            <button
                                style={{
                                    backgroundColor: "#ffffff",
                                    border: "none",
                                    marginTop: '-9px', marginLeft: '-6px'
                                }} title="Delete"
                            >
                                <img className="img-responsive"
                                    style={{
                                        marginTop: '6px',

                                        backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                    }}
                                    src={"./assets/images/baseline_delete_white_24dp.png"}
                                    onClick={() => (props.original.id) === '' ?
                                        this.fetchFaqDataApi() :
                                        this.setState({
                                            hideDeletePopup: true, deletePropIndex: props.index,
                                            propsId: props.original.id
                                        })}
                                />
                            </button>

                        </div>
                    </div>
                ),

            },

        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none' }}>
                    <div style={{ background: "#F9F9FB" }}>
                        {/* for toaster */}
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        {/* for reactTable */}
                        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                        {/*for dialog component */}
                        <link href="assets/css/ej2-base.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                        <link href="assets/css/screenResolution.css" rel="stylesheet" />

                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        {/* Select2 */}
                        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/toggleButton.css" />
                        <link rel="stylesheet" href="./assets/css/react-table-height.css" />


                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <h1 className="m-0 page-title">Frequently Asked Questions</h1>
                                        <h6 className="taglineTxt">Teach quick replies</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <Select
                                            value={this.faqLoadLanguages.filter(option => option.label === selectedLanguageOption)}
                                            onChange={this.handleLangChange}
                                            options={this.faqLoadLanguages} />
                                    </div>

                                    <div className="col-sm-4" style={{ marginBottom: '15px' }}>


                                        <Select
                                            value={this.domains.filter(option => option.label === selectedDomainOption)}
                                            onChange={this.handleDomainChange}
                                            options={this.domains} />
                                    </div>
                                    {/*search box */}

                                    {/* Add button */}
                                    <div className="col-sm-5" Align='right'>


                                        <div className="search-icon" Align='left' style={{
                                            marginBottom: '-43px', marginLeft: '-15px',
                                            backgroundColor: 'white', borderRadius: '26px',
                                            width: '291px', marginRight: '181px', paddingRight: '-39px', border: 'solid', height: '41px', marginTop: '3px'
                                        }}>
                                            <input className="border-none" type="search"
                                                onKeyPress={this.queryHandleChange}
                                                onChange={this.contentChange}

                                                placeholder="Search" aria-label="Search"
                                                style={{
                                                    position: "relative",
                                                    filterable: true, width: '234px',
                                                    font: 'bold', color: 'black', marginLeft: '3px',
                                                    marginTop: '4px', height: '20px', borderRadius: '16px'
                                                }}


                                                id="query" />
                                            <img src="assets/images/clear.png"
                                                onClick={this.reset}
                                                style={{
                                                    width: '14px', cursor: 'pointer',
                                                    display: this.state.showClearButton ? '' : 'none'
                                                }}
                                            />

                                            <img src="assets/images/search.svg"
                                                style={{ width: '14px', cursor: 'pointer' }}
                                                onClick={this.handleQuery}
                                            />
                                        </div>


                                        {/* <button className="btn action-button"
                                                onClick={() => { this.setState({ hideDeleteAllPopup: true }) }}>Delete All</button> */}

                                        <button className="btn action-button "
                                            title="Add"
                                            id="addMsg"
                                            style={{ marginRight: '-2px' }}
                                            onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addFaq}>
                                            <img src="assets/images/add_white_24dp.png" />
                                        </button>
                                        <button onClick={this.refreshData} className="btn action-button" style={{ marginRight: '-12px' }}
                                            title="Refresh">
                                            <img src="./assets/images/refresh_white_24dp.png"></img>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* left Menu start here*/}
                            {/* Content Header (Page header) */}
                            {/* /.content-header */}
                            {/* Custom Tabs */}
                            <div className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12 ">
                                            <div className="card">
                                                <ReactTable
                                                    data={data}
                                                    columns={columns}
                                                    defaultPageSize={10}
                                                    pageSizeOptions={[5, 10, 15]}
                                                    onPageChange={this.onPageChange}
                                                    page={this.state.pageNum}
                                                />
                                            </div>
                                            <ToastContainer className="Toast-at-center" />

                                            {/*Dialog Component For Deletion Confirmation*/}
                                            <DialogComponent width='400px' animationSettings={this.settings}
                                                header='Delete Question' showCloseIcon={true} buttons={this.buttons}
                                                ref={dialog => this.dialogInstance = dialog}
                                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                    content="" />&nbsp;Do you want to delete the question?&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;
                                                Note: If you delete the question, then aliases and answers
                                                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; will be deleted automatically.&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                Press 'Yes' to delete or press 'No' to decline..</DialogComponent>

                                            {/*Dialog Component For  Deletion all Confirmation*/}
                                            <DialogComponent width='400px' animationSettings={this.settings}
                                                header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
                                                ref={dialog => this.dialogInstance = dialog}
                                                visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
                                                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                    content="" />&nbsp;Do you want to delete all the FAQs?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                                            </DialogComponent>


                                            <DialogComponent width='400px' animationSettings={this.settings}
                                                header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
                                                ref={dialog => this.dialogInstance = dialog}
                                                visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
                                                Please type "Delete"
                                            </DialogComponent>


                                            <DialogComponent width='400px' animationSettings={this.settings}
                                                header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
                                                ref={dialog => this.dialogInstance = dialog}
                                                visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
                                                Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
                                            </DialogComponent>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Faq


// WEBPACK FOOTER //
// ./src/projectmgmt/faq/Faq.js